import IntlMessageFormat from 'intl-messageformat';
import get from 'lodash/get';
import { EEnvLocale } from '../env.types';
import { DEFAULT_LANGUAGE } from './constants';

let translations = {};

export class Translator {
  public static getFallbackLocale(inputLocale: string): EEnvLocale {
    if (inputLocale === 'en') return EEnvLocale.en;

    if (inputLocale === 'fr') return EEnvLocale.fr;

    if (inputLocale === 'de') return EEnvLocale.de;

    if (inputLocale === 'it') return EEnvLocale.it;

    if (inputLocale === 'es') return EEnvLocale.es;

    return EEnvLocale.en;
  }
  public static reset = () => delete Translator.instance;
  public static getInstance = (
    defaultLanguage: EEnvLocale,
    messages: object
  ): Translator =>
    !Translator.instance
      ? (Translator.instance = new Translator(defaultLanguage, messages))
      : Translator.instance;

  private static instance?: Translator;
  private messages: object;
  private locale: EEnvLocale;

  private constructor(defaultLanguage: EEnvLocale, messages: object) {
    this.locale = defaultLanguage;
    this.messages = messages;
  }

  public setLocale = (value: EEnvLocale): void => {
    this.locale = value;
  };

  public setTranslationsByLocale = (
    translationsValue: object,
    locale: string
  ): void => {
    translations[locale] = translationsValue;
    this.messages = translations;
  };

  public setTranslations = (translationsValue: object): void => {
    translations = translationsValue;
    this.messages = translations;
  };

  public translate = (translateKey: string, options?: object): string => {
    const message = get(this.messages[this.locale], translateKey);

    if (!message) return translateKey;

    return new IntlMessageFormat(message, this.locale).format(options);
  };

  public checkExist = (translateKey: string) => {
    const message = get(this.messages[this.locale], translateKey);

    if (!message) return false;

    return true;
  };
}

export const i18n = Translator.getInstance(DEFAULT_LANGUAGE, translations);
